<template>
  <div>
    <e-filters
      ref="filters"
      :title="$t('Filtros')"
      :searching="fetching"
      :show-search-button="false"
      @reset="resetFilters"
    >
      <template #after_buttons>
        <e-button
          id="download"
          class="ml-1 btn-sm-block"
          variant="primary"
          icon="download"
          :busy="fetching"
          :text="$t('Baixar Relatório')"
          @click="downloadReport"
        />
        <!-- Button to download report (hidden by default) -->
        <a
          ref="downloadLink"
          style="display: none"
        />
      </template>
      <b-row>
        <b-col md="4">
          <e-store-combo
            id="filter-store"
            v-model="filters.storeId"
            :required="false"
          />
        </b-col>
        <b-col md="4">
          <FormulateInput
            id="filter-motoboy"
            v-model="filters.motoboyId"
            type="vue-select"
            :label="$t('Motoboy')"
            :placeholder="$t('Todos')"
            :options="getComboMotoboys"
            :disabled="!filters.storeId"
          />
        </b-col>
        <b-col md="4">
          <FormulateInput
            id="filter-delivery-status"
            v-model="filters.deliveryStatus"
            type="vue-select"
            :label="$t('Status da entrega')"
            :placeholder="$t('Todos')"
            :options="deliveryStatusOptions()"
          />
        </b-col>
        <b-col md="6">
          <FormulateInput
            id="filter-period"
            v-model="filters.period"
            type="date-range-picker"
            :label="$t('Período')"
            :time-picker="false"
            class="required"
            validation="required"
          />
        </b-col>
      </b-row>
    </e-filters>
  </div>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import { formulateValidation, statusTypes } from '@/mixins'
import { mapActions, mapGetters, mapState } from 'vuex'
import moment from 'moment'
import { EStoreCombo, EFilters } from '@/views/components'
import EButton from '@/views/components/EButton.vue'

const MAX_PERIOD_DAYS = 90

export default {
  components: {
    BRow,
    BCol,
    EFilters,
    EStoreCombo,
    EButton,
  },

  mixins: [formulateValidation, statusTypes],

  data() {
    return {
      fetching: false,
    }
  },

  computed: {
    ...mapState('pages/reports/delivery/motoboyDelivery', ['reportData', 'filters']),
    ...mapGetters('pages/reports/delivery/motoboyDelivery', ['getComboMotoboys']),
  },

  watch: {
    // A lista de motoboys é por loja, então ela precisa ser recarregada (e a seleção
    // anterior descartada) sempre que a loja do filtro mudar.
    'filters.storeId': {
      async handler() {
        this.filters.motoboyId = null
        try {
          await this.fetchMotoboys()
        } catch (error) {
          this.showError({ error })
        }
      },
      immediate: true,
    },
  },

  methods: {
    ...mapActions('pages/reports/delivery/motoboyDelivery', [
      'generateReport',
      'fetchMotoboys',
      'resetFilters',
    ]),

    async downloadReport() {
      try {
        if (!this.$refs.filters.isValid()) return

        const { startDate, endDate } = this.filters.period
        if (
          !startDate ||
          !endDate ||
          moment(endDate).diff(moment(startDate), 'days') > MAX_PERIOD_DAYS
        ) {
          this.showInvalidDataMessage({
            message: this.$t('Informe um período de no máximo 90 dias para baixar o relatório'),
          })
          return
        }

        this.fetching = true
        await this.generateReport()

        const { downloadLink } = this.$refs
        if (!this.reportData) {
          this.showError({ message: this.$t('Não foi possível recuperar os dados do relatório') })
          return
        }

        downloadLink.href = this.reportData
        downloadLink.download = `EntregasPorMotoboy-Loja_${this.filters.storeId || 'Todas'}-Data_${startDate}_ate_${endDate}.xlsx`
        downloadLink.click()
      } catch (error) {
        this.showError({ error })
      } finally {
        this.fetching = false
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
